var map = {
	"./img_0.png": 672,
	"./img_1.png": 673,
	"./img_2.png": 674,
	"./img_3.png": 675,
	"./img_4.png": 676,
	"./img_5.png": 677,
	"./img_6.png": 678,
	"./img_7.png": 679,
	"./img_8.png": 680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;